"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const NavigateBack = createSvgIcon(
  <path d="M9.29808 11.9991L14.6058 6.69141L15.3135 7.39911L10.7135 11.9991L15.3135 16.5991L14.6058 17.3068L9.29808 11.9991Z" />,
  "NavigateBack",
)

const NavigateBackIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <NavigateBack sx={{ fill: _fill, ...sx }} {...rest} />
}

export default NavigateBackIcon
